import script from "./saleNew.vue?vue&type=script&setup=true&lang=js"
export * from "./saleNew.vue?vue&type=script&setup=true&lang=js"

import "./saleNew.vue?vue&type=style&index=0&id=36f01ca2&scoped=true&lang=css"

import exportComponent from "/Users/lock/vuework/yaojing-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36f01ca2"]])

export default __exports__